<template>
  <div
    class="confidence-score-explanation i-mt-10 i-p-10 i-text-neutral-120 i-radius-md"
  >
    <h5 class="i-text-button-3">
      {{ confidenceScoreTitle }}
    </h5>
    <p
      v-for="(point, index) in confidenceScorePoints"
      :key="index"
      class="i-text-body-3 i-mb-4 d-flex"
    >
      <i-icon
        symbol="small-solid-info"
        class="i-mt-1 i-mr-4 i-text-neutral-90"
        :size="12"
      />
      <span v-html="point"></span>
    </p>
  </div>
</template>

<script>
import { iIcon } from '@inscribe/signal';
import creditConfidenceScoreInfo from './CreditConfidenceScoreInfo.content';

export default {
  components: {
    iIcon,
  },
  props: {
    hasHighConfidenceScore: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    confidenceScoreTitle() {
      return this.hasHighConfidenceScore
        ? creditConfidenceScoreInfo.high.title
        : creditConfidenceScoreInfo.low.title;
    },
    confidenceScorePoints() {
      return this.hasHighConfidenceScore
        ? creditConfidenceScoreInfo.high.points
        : creditConfidenceScoreInfo.low.points;
    },
  },
};
</script>
<style lang="scss" scoped>
.confidence-score-explanation {
  background-color: $light-neutral-default;

  p {
    .i-icon {
      flex-shrink: 0;
    }
    &:last-child {
      margin-bottom: 0 !important;
    }
  }
}
</style>
